import { motion } from 'framer-motion';
import { availableLetters } from '../data/available-letters';

interface AlphabetFilterProps {
  selectedLetter: string | null;
  onLetterSelect: (letter: string) => void;
  gender: 'boys' | 'girls' | null;
}

export default function AlphabetFilter({ selectedLetter, onLetterSelect, gender }: AlphabetFilterProps) {
  const letters = gender ? availableLetters[gender] : [];

  return (
    <div className="mb-8">
      <h3 className="text-lg font-medium text-gray-700 mb-3">Browse by Letter</h3>
      <div className="flex flex-wrap gap-2">
        {letters.map((letter) => (
          <motion.button
            key={letter}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onLetterSelect(letter)}
            className={`w-10 h-10 rounded-lg flex items-center justify-center text-sm font-medium transition-colors ${
              selectedLetter === letter
                ? 'bg-purple-600 text-white'
                : 'bg-white text-gray-600 hover:bg-purple-50'
            }`}
          >
            {letter.toUpperCase()}
          </motion.button>
        ))}
      </div>
    </div>
  );
}